import addFilterCounts from './add-filter-counts';

/**
 * Given an array of report posts and arrays of taxonomy terms for communities,
 * program areas, and topics, builds a filter list for use with the
 * Filters component and returns it.
 * @param {Array} research - An array of Research posts.
 * @param {Array} communities - An array of community taxonomy terms.
 * @param {Array} programAreas - An array of program area taxonomy terms.
 * @param {Array} topics - An array of topic taxonomy terms.
 * @param {Array} reportTypes - An array of Report Type taxonomy terms.
 * @returns {Array} An array of filters.
 */
const filtersFromResearch = (
  research,
  communities,
  programAreas,
  topics,
  reportTypes,
) => addFilterCounts(research
  // Process posts into filters and store counts along with labels and values.
  .reduce((acc, item) => {
    const {
      communities: communityTerms = [],
      date = '',
      'program-areas': programAreaTerms = [],
      topics: topicTerms = [],
      'report-types': reportTypesTerms = [],
    } = item;

    // Add publish date.
    if ('' !== date) {
      const year = date.substring(0, 4);
      acc[1].options.push({
        label: year,
        value: year,
      });
    }

    // Create a taxonomy map to avoid repeating code for each taxonomy.
    const taxMap = [
      {
        ids: programAreaTerms,
        index: 0,
        terms: programAreas,
      },
      {
        ids: communityTerms,
        index: 2,
        terms: communities,
      },
      {
        ids: topicTerms,
        index: 3,
        terms: topics,
      },
      {
        ids: reportTypesTerms,
        index: 4,
        terms: reportTypes,
      },
    ];
    // Add terms.
    taxMap.forEach(({ ids, index, terms }) => {
      ids.forEach((id) => {
        const term = terms.find(({ id: compare }) => compare === id);
        if (term) {
          acc[index].options.push({
            label: term.name,
            value: String(id),
          });
        }
      });
    });

    return acc;
  }, [{
    label: 'Programs',
    options: [],
    type: 'program-areas',
  },
  {
    label: 'Years',
    options: [],
    type: 'years',
  },
  {
    label: 'Communities',
    options: [],
    type: 'communities',
  },
  {
    label: 'Topics',
    options: [],
    type: 'topics',
  },
  {
    label: 'Report Types',
    options: [],
    type: 'report-types',
  }]));

export default filtersFromResearch;
